(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxPostactionWizard', {
		bindings: {
			isActive: '=',
			action: '@',
		},
		controller: MxPostActionWizardCtrl,
		controllerAs: 'vm',
	});

	MxPostActionWizardCtrl.$inject = ['mx.shell.EventService', 'mx.shell.ActionManagerService', 'mx.shell.ActionExecutorService', '$scope'];

	function MxPostActionWizardCtrl(eventService, actionManagerService, actionExecutorService, $scope) {
		var vm = this;

		eventService.subscribeTo(
			mx.shell.EventCodes.WizardPostAction,
			function (event, context) {
				if (vm.isActive && Boolean(vm.action) && Boolean(context) && Boolean(context.ObjectReferences) && context.ObjectReferences.length > 0) {
					actionManagerService.getAllActions().then(function (actions) {
						for (var action in actions) {
							if (actions.hasOwnProperty(action)) {
								if (actions[action].name === vm.action) {
									actionExecutorService.execute(actions[action], context.ObjectReferences).catch(mx.logCatch);
									break;
								}
							}
						}
					});
				}
			},
			$scope
		);

		return vm;
	}
})();
